export default __webpack_public_path__ + "static/media/positive-review.03d26fbf.svg";